import { render, staticRenderFns } from "./EditSupplier.vue?vue&type=template&id=354cd49b&scoped=true"
import script from "./EditSupplier.vue?vue&type=script&lang=js"
export * from "./EditSupplier.vue?vue&type=script&lang=js"
import style0 from "./EditSupplier.vue?vue&type=style&index=0&id=354cd49b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354cd49b",
  null
  
)

export default component.exports